class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = document.querySelector('.cart-drawer__overlay');
    this.closeBtn = this.querySelector('.cart-drawer__close');
    this.loader = this.querySelector('.cart-drawer__loader');
    this.form = this.querySelector('.cart-drawer-buttons #cart-form');

    if (this.form) {
      this.form.addEventListener('submit', (e) => this.onFormSubmit(e));
    }

    // bind handlers
    this.handleQtyClick = this.handleQtyClick.bind(this);
    this.inputHandleQtyClick = this.inputHandleQtyClick.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
    this.handleUpsellClick = this.handleUpsellClick.bind(this);
    this.handleToggleNote = this.handleToggleNote.bind(this);
    this.open = this.open.bind(this);

    // Event listeners
    this.onNoteBlur = this.onNoteBlur.bind(this);
    this.overlay.addEventListener('click', () => this.close());
    this.closeBtn.addEventListener('click', () => this.close());
    this.delegateEvents(); // Attach event delegation
  }

  showLoader() {
    this.loader.classList.remove('hidden');
  }

  hideLoader() {
    this.loader.classList.add('hidden');
  }

  onFormSubmit(event) {
    this.showLoader();
  }

  delegateEvents() {
    this.querySelectorAll('.qty-btn').forEach((btn) => btn.addEventListener('click', this.handleQtyClick));
    this.querySelectorAll('.cart-drawer__quantity input').forEach((input) =>
      input.addEventListener('change', this.inputHandleQtyClick)
    );

    this.querySelectorAll('.cart-drawer__remove').forEach((removeBtn) =>
      removeBtn.addEventListener('click', this.handleRemoveClick)
    );

    this.querySelectorAll('.upsell-add').forEach((removeBtn) =>
      removeBtn.addEventListener('click', this.handleUpsellClick)
    );

    this.querySelectorAll('.toggle-note').forEach((removeBtn) =>
      removeBtn.addEventListener('click', this.handleToggleNote)
    );

    this.querySelectorAll('.save-note').forEach((elm) => elm.addEventListener('click', this.onNoteBlur));

    // const noteField = this.querySelector('.cart-note');
    // if (noteField) {
    //   noteField.removeEventListener('blur', this.saveNote);
    //   noteField.addEventListener('blur', () => this.saveNote());
    // }

    this.updateMinusButtonStates();
  }

  handleQtyClick(e) {
    this.updateQuantity(e);
  }

  inputHandleQtyClick(e) {
    const item = e.target.closest('.cart-drawer__item');
    let qty = parseInt(e.target.value);
    this.changeQuantity(item.dataset.key, qty);
  }

  handleRemoveClick(e) {
    const key = e.target.closest('.cart-drawer__item').dataset.key;
    this.changeQuantity(key, 0);
  }

  handleUpsellClick(e) {
    const variantId = e.target.dataset.variant;
    this.addProduct(variantId, e.target);
  }

  handleToggleNote() {
    this.toggleNote();
  }

  toggleNote() {
    const wrapper = this.querySelector('.note-wrapper');
    wrapper.classList.toggle('hidden');

    const parentElm = this.querySelector('.cart-drawer__note');
    parentElm.classList.toggle('note-open');
  }

  onNoteBlur() {
    this.saveNote();
  }

  async saveNote() {
    this.showLoader();
    const noteValue = this.querySelector('#CartNote').value;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: noteValue }),
    });
    // Optionally refresh drawer so note persists
    await this.refresh();
    this.hideLoader();
  }

  updateMinusButtonStates() {
    this.querySelectorAll('.cart-drawer__quantity').forEach((qtyEl) => {
      const input = qtyEl.querySelector('input');
      const minusBtn = qtyEl.querySelector('.minus');
      if (parseInt(input.value) <= 1) {
        minusBtn.disabled = true;
      } else {
        minusBtn.disabled = false;
      }
    });
  }

  async changeQuantity(itemKey, newQty) {
    console.log('test', itemKey, newQty);
    this.showLoader();
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: newQty }),
    });
    await this.refresh();
    this.hideLoader();
  }

  async addProduct(variantId, qty = 1) {
    this.showLoader();
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty }),
    });
    await this.refresh();
    this.hideLoader();
  }

  async refresh() {
    const section_id = this.dataset.id;
    const res = await fetch(`/?section_id=${section_id}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newBody = doc.querySelector('#CartDrawerBody');
    const newCount = doc.querySelector('#CartCount');
    const drawerBody = this.querySelector('#CartDrawerBody');
    drawerBody.innerHTML = newBody.innerHTML;

    const headerCount = document.querySelector('.header-cart__count');
    if (headerCount) {
      headerCount.textContent = newCount.textContent;
    }

    this.delegateEvents();
  }

  updateQuantity(e) {
    const item = e.target.closest('.cart-drawer__item');
    const input = item.querySelector('input');
    let qty = parseInt(input.value);

    if (e.target.classList.contains('plus')) qty++;
    if (e.target.classList.contains('minus') && qty > 1) qty--;

    this.changeQuantity(item.dataset.key, qty);
  }

  open() {
    this.classList.add('drawer-open');
    document.querySelector('body').classList.add('body-drawer-overflow');
  }

  close() {
    this.classList.remove('drawer-open');
    document.querySelector('body').classList.remove('body-drawer-overflow');
  }
}

customElements.define('cart-drawer', CartDrawer);

class AddVariantItem extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.id;
    this.drawer = document.querySelector('cart-drawer');
    this.addEventListener('click', () => this.addToCart());
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.classList.add('loading');
      this.disabled = true;
      this.innerHTML = `<span class="btn-spinner"></span>`;
    } else {
      this.classList.remove('loading');
      this.disabled = false;
      this.textContent = 'Add';
    }
  }

  async addToCart() {
    if (!this.variantId || !this.drawer) return;

    this.setLoading(true);
    this.drawer.showLoader();

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.variantId,
          quantity: 1,
          properties: {
            'Please Note':
              'Processing time is 1-3 business days on top of shipping. We recommend Express with Ice for Warm Weather.',
          },
        }),
      });

      await this.drawer.refresh();
      this.drawer.hideLoader();
      this.drawer.open();

      // Success state
      this.textContent = 'Added';
      setTimeout(() => {
        this.textContent = 'Add';
        this.disabled = false;
      }, 1500);
    } catch (err) {
      console.error('Add to cart failed', err);
      this.setLoading(false);
    }
  }
}

customElements.define('add-variant-item', AddVariantItem);

class CartIcon extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
  }
}
customElements.define('cart-icon', CartIcon);

// Global function for scrolling
window.initCustomHorizontalScroll = function (containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const track = container.parentElement.querySelector('.custom-scrollbar-track-horizontal');
  const thumb = container.parentElement.querySelector('.custom-scrollbar-thumb-horizontal');

  function checkHorizontalOverflow() {
    if (container.scrollWidth > container.clientWidth) {
      container.classList.remove('default-spacing');
      container.classList.add('scroll-x-spacing');
    } else {
      container.classList.remove('scroll-x-spacing');
      container.classList.add('default-spacing');
    }
  }

  function updateThumbWidth() {
    if (!track || !thumb) return;
    const ratio = container.clientWidth / container.scrollWidth;
    thumb.style.width = `${track.clientWidth * ratio}px`;
  }

  function updateThumbPosition() {
    if (!track || !thumb) return;
    const scrollRatio = container.scrollLeft / container.scrollWidth;
    const left = scrollRatio * track.clientWidth;
    thumb.style.left = `${left}px`;
  }

  container.addEventListener('scroll', updateThumbPosition);

  // Drag functionality
  if (thumb && track) {
    let isDragging = false;
    let startX, startScrollLeft;

    thumb.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
      startScrollLeft = container.scrollLeft;
      document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const dx = e.clientX - startX;
      const scrollRatio = container.scrollWidth / track.clientWidth;
      container.scrollLeft = startScrollLeft + dx * scrollRatio;
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
      document.body.style.userSelect = 'auto';
    });
  }

  // Run once on init
  checkHorizontalOverflow();
  updateThumbWidth();
  updateThumbPosition();
};

// const headerCartIcon = document.querySelector('.header-cart-icon');
// if (headerCartIcon) {
//   const CartDrawer = document.querySelector('cart-drawer');
//   if (CartDrawer) {
//   }
//   headerCartIcon.addEventListener('click', () => CartDrawer.open());
// }

// Menu Image Source change
$('.navigation__container ul li').hover(function () {
  var target = $(this).find('.nav-collection_image img').attr('src');
  $('.menu_hover_img img').attr('src', target);
});

//  Menu Open JS
// let items = document.querySelector(".navigation__container").querySelectorAll("site-nav__item");
//   console.log(items)
//   items.forEach(item => {
//     item.addEventListener("mouseover", () => {
//       item.setAttribute("open", true);
//       item.querySelector("ul").addEventListener("mouseleave", () => {
//         item.removeAttribute("open");
//       });
//     item.addEventListener("mouseleave", () => {
//       item.removeAttribute("open");
//     });
//   });
//   });

// Submenu active js
//   $('ul.submenu_list_items li').hover(function() {
//     $('ul.submenu_list_items li.current').removeClass('current');
//     $(this).closest('li').addClass('current');
// });

$('ul.submenu_list_items li.sub_list').hover(function () {
  $(this).addClass('current').siblings().removeClass('current');
  var Title = $(this).data('title');
  $('.grandmenu_listitem').each(function () {
    var checkTitle = $(this).data('value');
    if (Title == checkTitle) {
      $(this).addClass('mega_active');
    } else {
      $(this).removeClass('mega_active');
    }
  });
});

$('form.club_form input#yes').click(function () {
  $('.join_Club_address').show();
});
$('form.club_form input#no').click(function () {
  $('.join_Club_address').hide();
});

$('.header__search svg.icon-search').click(function () {
  $(this).closest('.header__search').find('details').attr('open', true);
  return false;
});
$(document).find('#insta-feed').closest('.shopify-block.shopify-app-block').addClass('custom_insta_block');

document.addEventListener('DOMContentLoaded', function () {
  const filterContainer = document.querySelector('.cc-filters-container');
  if (filterContainer) {
    const typeItems = document.querySelectorAll('.cc-filter__types .cc-filter__item');
    const checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.custom_candy_type"]');

    document.querySelectorAll('.cc-filter__types .cc-filter__item').forEach((item) => {
      item.addEventListener('click', function () {
        const value = item.dataset.value;
        // Find checkbox with this value
        const checkbox = document.querySelector(`input[name="filter.p.m.custom.custom_candy_type"][value="${value}"]`);

        if (checkbox) {
          // click its next label element
          const label = checkbox.nextElementSibling;
          if (label) {
            label.click(); // triggers the filter + toggle
            item.classList.toggle('active');
          }
        } else {
          const checkedFilters = document.querySelectorAll(`input[name="filter.p.m.custom.custom_candy_type"]:checked`);
          if (checkedFilters) {
            checkedFilters.forEach((input) => {
              input.click();
            });
          }
          item
            .closest('.cc-filter__types')
            .querySelectorAll('.cc-filter__item')
            .forEach((item) => {
              item.classList.remove('active');
            });
          item.classList.toggle('active');
        }

        const activeFilters = document.querySelectorAll('.cc-filter__types .cc-filter__item.active');
        const allFilter = document.querySelector('.cc-filter__types .cc-filter__item[data-value="all"]');
        if (activeFilters.length > 0) {
          if (allFilter) {
            allFilter.classList.remove('active');
          }
        } else {
          if (allFilter) {
            setTimeout(() => {
              allFilter.classList.add('active');
            }, 1500);
          }
        }
      });
    });
  }

  new StickyAddToCart();

  const stickyAtcBtn = document.querySelector('.sticky-product-right [data-add-to-cart]');
  const mainAtcBtn = document.querySelector('.product-atc-button');
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', () => {
      if (mainAtcBtn) {
        mainAtcBtn.click();
      }
    });
  }
});

class StickyAddToCart {
  constructor() {
    this.addCartMain = document.querySelector('.product-atc-button');

    if (!this.addCartMain) return;

    const options = {
      root: null,
      rootMargin: '50px 0px 0px 0px', // adjust as needed
      threshold: 0, // trigger when button fully leaves viewport
    };

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);

    this.observer.observe(this.addCartMain);
  }

  handleIntersect(entries) {
    const entry = entries[0];
    const isVisible = entry.isIntersecting;

    if (!isVisible) {
      this.addCartMain.classList.add('is-active');
      document.body.classList.add('sticky-product-active');
    } else {
      this.addCartMain.classList.remove('is-active');
      document.body.classList.remove('sticky-product-active');
    }
  }
}
